import { render, staticRenderFns } from "./UnlockFeed.vue?vue&type=template&id=1a9fec50&"
import script from "./UnlockFeed.vue?vue&type=script&lang=ts&"
export * from "./UnlockFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports